import React, { useEffect, useState } from "react";
import DialogWrapMedium from "../../../controls/components/dialogWrap/DialogWrap";
import { FomrmLoginInput } from "../../LoginUser/styled/LoginStyles";
import { TextField } from "@material-ui/core";
import {
	InputOrderAdminTitle,
	UserFormServiceButtonClose,
	UserFormServiceButtonCreated,
} from "../../MyBooking/styled/DesStyled";
import useUpdateReviewsPartner from "../hook/useUpdateReviewsPartner";
import usePartnerDetail from "../hook/useGetUserDetail";
import { uploadAvatarMutiImage } from "../../../../services/PartnerService";
import http from "../../../../services/http";
import {
	PartnerbuttonRemoteImage,
	PartnerImage,
	PartnerImageInner,
	PartnerImageWrap,
} from "../../PersonalInformation/styled/PersonInfoStyled";

export default function DialogReviewsPartner(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	partnerId: string;
	reload: () => void;
}) {
	const { loadUpdateReviews } = useUpdateReviewsPartner({ reload: props.reload });
	const { userDetail } = usePartnerDetail({ id: props.partnerId, openDialog: props.openDialog });

	const [reviews, setReviews] = useState<any[]>([
		{ id: 1, rating: 5, text: '', author: '', date: '', avatar: '/static/img/avatar-review1.png' }
	]);

	useEffect(() => {
		if (props.openDialog && userDetail) {
			const partnerReviews = (userDetail as any).reviews;
			if (partnerReviews && Array.isArray(partnerReviews)) {
				setReviews(partnerReviews.length > 0 ? partnerReviews : [
					{ id: 1, rating: 5, text: '', author: '', date: '', avatar: '/static/img/avatar-review1.png' }
				]);
			}
		}
	}, [userDetail, props.openDialog]);

	const handleAddReview = () => {
		const avatarIndex = (reviews.length % 4) + 1;
		setReviews([...reviews, {
			id: reviews.length + 1,
			rating: 5,
			text: '',
			author: '',
			date: '',
			avatar: `/static/img/avatar-review${avatarIndex}.png`
		}]);
	};

	const handleRemoveReview = (index: number) => {
		if (reviews.length > 1) {
			const newReviews = reviews.filter((_, i) => i !== index);
			setReviews(newReviews);
		}
	};

	const handleChange = (index: number, field: string, value: any) => {
		const newReviews = [...reviews];
		newReviews[index] = {
			...newReviews[index],
			[field]: value
		};
		setReviews(newReviews);
	};

	const handleAvatarUpload = (index: number, file: File) => {
		if (file && file.type.startsWith('image/')) {
			const reader = new FileReader();
			reader.onloadend = () => {
				const dataUrl = reader.result as string;
				const newReviews = [...reviews];
				newReviews[index] = {
					...newReviews[index],
					avatar: dataUrl
				};
				setReviews(newReviews);
			};
			reader.readAsDataURL(file);
		}
	};

	const handleSave = async () => {
		const reviewsToSave = [...reviews];
		
		for (let i = 0; i < reviewsToSave.length; i++) {
			if (reviewsToSave[i].avatar && reviewsToSave[i].avatar.startsWith('data:image/')) {
				try {
					const base64Data = reviewsToSave[i].avatar.split(',')[1];
					const buffer = Uint8Array.from(atob(base64Data), c => c.charCodeAt(0));
					const blob = new Blob([buffer], { type: 'image/jpeg' });
					const file = new File([blob], `avatar-${i}.jpg`, { type: 'image/jpeg' });
					
					const formData = new FormData();
					formData.append('images', file);
					
					const result = await http.post('/gcs-upload-multiple-image?folder=partners/reviews', formData, {
						headers: { 'Content-Type': 'multipart/form-data' }
					});
					
					if (result.data && result.data.length > 0) {
						reviewsToSave[i].avatar = result.data[0].path;
					}
				} catch (err) {
					console.error('Error uploading avatar:', err);
				}
			}
		}
		
		await loadUpdateReviews(props.partnerId, reviewsToSave);
		props.setOpenDialog(false);
	};

	return (
		<DialogWrapMedium
			login={true}
			open={props.openDialog}
			onClose={() => props.setOpenDialog(false)}
		title="Manage Reviews"
		actions={
			<>
				<UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
					Cancel
				</UserFormServiceButtonClose>
				<UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
			</>
		}>
			<div>
				<div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<strong style={{ fontSize: '16px' }}>Customer Reviews</strong>
					<button onClick={() => handleAddReview()} style={{ 
						padding: '8px 16px', 
						background: '#2563EB', 
						color: 'white', 
						border: 'none', 
						borderRadius: '4px',
						cursor: 'pointer',
						fontSize: '14px'
					}}>
						+ Add Review
					</button>
				</div>
				<div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
				{reviews.map((review, index) => (
					<div key={index} style={{ 
						marginBottom: '24px', 
						padding: '16px', 
						border: '1px solid #ddd', 
						borderRadius: '8px' 
					}}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
							<strong>Review #{index + 1}</strong>
							{reviews.length > 1 && (
								<button onClick={() => handleRemoveReview(index)}>Remove</button>
							)}
						</div>
						
						<InputOrderAdminTitle>Rating (1-5)</InputOrderAdminTitle>
						<FomrmLoginInput
							type="number"
							min="1"
							max="5"
							placeholder="5"
							value={review.rating}
							onChange={(e) => handleChange(index, 'rating', parseInt(e.target.value))}
						/>
						
						<InputOrderAdminTitle>Review Text</InputOrderAdminTitle>
						<TextField
							multiline
							rows={3}
							placeholder="Enter review text..."
							value={review.text}
							onChange={(e) => handleChange(index, 'text', e.target.value)}
							fullWidth
							variant="outlined"
							style={{ marginBottom: '16px' }}
						/>
						
						<InputOrderAdminTitle>Author Name</InputOrderAdminTitle>
						<FomrmLoginInput
							placeholder="Author name"
							value={review.author}
							onChange={(e) => handleChange(index, 'author', e.target.value)}
						/>
						
						<InputOrderAdminTitle>Date</InputOrderAdminTitle>
						<FomrmLoginInput
							placeholder="e.g., June 2024"
							value={review.date}
							onChange={(e) => handleChange(index, 'date', e.target.value)}
						/>
						
						<InputOrderAdminTitle>Avatar</InputOrderAdminTitle>
						<div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
							{review.avatar && (
								<img 
									src={review.avatar} 
									alt="avatar" 
									style={{ 
										width: '80px', 
										height: '80px', 
										borderRadius: '50%', 
										objectFit: 'cover',
										border: '3px solid #e5e7eb',
										boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
									}}
								/>
							)}
							<label style={{
								display: 'inline-block',
								padding: '8px 16px',
								background: '#2563EB',
								color: 'white',
								borderRadius: '4px',
								cursor: 'pointer',
								fontSize: '14px'
							}}>
								Upload Avatar
								<input
									type="file"
									accept="image/*"
									onChange={(e) => {
										const file = e.target.files?.[0];
										if (file) {
											handleAvatarUpload(index, file);
										}
									}}
									style={{ display: 'none' }}
								/>
							</label>
						</div>
					</div>
				))}
				</div>
			</div>
		</DialogWrapMedium>
	);
}
